















































































import { Component, Mixins } from "vue-property-decorator";
import AdminBrandId from "@/mixins/adminBrandId";
import StatsStorageMixin from "@/mixins/statsStorageMixin";
import dateranges from "@/data/dateranges";

@Component({
  components: {
    "stat-header": () => import("@/components/app/global/stats/statHeader.vue"),
    "timeline-component": () =>
      import("@/components/app/global/timelineComponent/index.vue"),
    "affiliates-provider": () =>
      import("@/components/app/global/affiliate/affiliatesProvider.vue"),
    "recent-affiliates-list": () =>
      import("@/components/app/global/affiliate/recentAffiliatesList.vue"),
    "affiliate-total-unpaid": () =>
      import("@/components/app/global/stats/affiliateTotalUnpaid.vue"),
    "affiliate-total-paid-out-commission": () =>
      import(
        "@/components/app/global/stats/affiliateTotalPaidOutCommissions.vue"
      ),
    "affiliate-total-pending-commission": () =>
      import(
        "@/components/app/global/stats/affiliateTotalPendingCommissions.vue"
      ),
    "affiliate-referrals-total-count": () =>
      import("@/components/app/global/stats/affiliateReferralsTotalCount.vue"),
    "affiliate-orders-total-count": () =>
      import("@/components/app/global/stats/affiliateOrdersTotalCount.vue")
  }
})
export default class AdminAffiliatesOverview extends Mixins(
  AdminBrandId,
  StatsStorageMixin
) {
  public range = this.tryGetStatDateFromStorage(dateranges.ranges.last30days);

  public currencyCode = null;
}
